import { render } from "./Statistic.vue?vue&type=template&id=ce16fa90&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import "./Statistic.vue?vue&type=style&index=0&id=ce16fa90&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce16fa90"]])

export default __exports__